import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReference: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconReference"><Path fillRule="evenodd" clipRule="evenodd" d="M20 22H6.25C5.00736 22 4 20.9926 4 19.75V4.75C4 3.23122 5.23122 2 6.75 2H20V22ZM6.25 19C5.83579 19 5.5 19.3358 5.5 19.75C5.5 20.1642 5.83579 20.5 6.25 20.5H18.5V19H6.25ZM6.25 16C5.83579 16 5.5 16.3358 5.5 16.75C5.5 17.1642 5.83579 17.5 6.25 17.5H18.5V16H6.25ZM8 6V7.5H16V6H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReference;
